import {Component, EventEmitter, OnInit, Output} from '@angular/core';

export interface integrationItem {
  name: string;
  url: string;
}

@Component({
  selector: 'dsm-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.less']
})
export class IntegrationsComponent implements OnInit {
  @Output() public onEmptyStateSubmit$: EventEmitter<void> = new EventEmitter();

  allIntegrations: integrationItem[] = [
    {name: 'agheera', url: 'integracja-agheera-gmbh-z-systemem-mycar-business'},
    {name: 'asstra', url: 'integracja-asstra-z-systemem-mycar-business'},
    {name: 'carmen', url: 'integracja-carmen-z-systemem-mycar-busines'},
    {name: 'co3', url: 'integracja-co3-z-systemem-mycar-business'},
    {name: 'eago-systems', url: 'integracja-eago-cz-z-systemem-mycar-business'},
    {name: 'e-track', url: 'integracja-trans-eu-z-systemem-mycar-business'},
    {name: 'fire-tms', url: 'integracja-firetms-z-systemem-mycar-business'},
    // {name: 'four-kites', url: 'display/MYC/FourKites'},
    {name: 'gefco', url: 'integracja-gefco-t-t-z-systemem-mycar-business'},
    {name: 'kart-gis', url: 'integracja-kartgis-z-systemem-mycar-business'},
    {name: 'kiedy-przyjedzie', url: 'integracja-kiedyprzyjedzie-pl-z-systemem-mycar-business'},
    {name: 'kurier-system', url: 'integracja-kurier-system-z-systemem-mycar-business'},
    {name: 'linkway', url: 'integracja-linkway-integrator-z-systemem-mycar-business'},
    {name: 'lkw-walter', url: 'integracja-lkw-walter-z-systemem-mycar-business'},
    // {name: 'spedtrans', url: ''},
    {name: 'nic', url: 'integracja-nic-place-z-systemem-mycar-business-7-11-2022'},
    {name: 'project44', url: 'integracja-project44-z-systemem-mycar-business'},
    {name: 'shippeo', url: 'integracja-shippeo-z-systemem-mycar-business'},
    {name: 'sky-logic', url: 'integracja-skylogic-tms-benson-consultants-z-systemem-mycar-business'},
    {name: 'softra', url: 'integracja-softra-z-systemem-mycar-business'},
    {name: 'sostmeier', url: 'integracja-sostmeier-gmbh-co-kg-z-systemem-mycar-business'},
    {name: 'timocom', url: 'integracja-timocom-z-systemem-mycar-business'},
    {name: 'trans-eu', url: 'integracja-trans-eu-z-systemem-mycar-business'},
    {name: 'van-group', url: 'integracja-van-group-z-systemem-mycar-business'},
    {name: 'wialon', url: 'integracja-wialon-z-systemem-mycar-business'},
    {name: 'corcode', url: 'integracja-corcode-z-systemem-mycar-business'},
    {name: 'dbschenker', url: 'integracja-dbschenker-z-systemem-mycar-business'},
    {name: 'fourkites', url: 'integracja-fourkites-z-systemem-mycar-business'},
    {name: 'maciosoft', url: 'integracja-maciosoft-z-systemem-mycar-business'},
    {name: 'pascom', url: 'integracja-pascom-z-systemem-mycar-business'},
    {name: 'nmierp', url: 'integracja-nmierp-z-systemem-mycar-business'},
    {name: 'ivalon', url: 'integracja-ivalon-z-systemem-mycar-business'},
    {name: 'quehenberger', url: 'integracja-quehenberger-z-systemem-mycar-business'},
    {name: 's3pweb', url: 'integracja-s3pweb-z-systemem-mycar-business'},
    {name: 'sixfold', url: 'integracja-sixfold-z-systemem-mycar-business'},
    {name: 'transporeon', url: 'integracja-transporeon-z-systemem-mycar-business'},
    {name: 'trimble', url: 'integracja-trimble-z-systemem-mycar-business'},
    {name: 'slickshift', url: 'integracja-slickshift-z-systemem-mycar-business'},
    {name: 'softhard', url: 'integracja-softhard-z-systemem-mycar-business'},
    {name: 'veroo', url: 'integracja-veroo-z-systemem-mycar-business'},
    {name: 'yetiforce', url: 'integracja-yetiforce-z-systemem-mycar-business'},
    {name: 'drip', url: 'integracja-drip-z-systemem-mycar-business'},
    // {name: 'descrtes', url: ''},
  ];

  filtered: integrationItem[] = [];
  public searchValue: string;

  constructor() {
    this.setInitValues();
  }

  private setInitValues(): void {
    this.allIntegrations = this.allIntegrations.sort(this.sort);
    this.filtered = this.getClone(this.allIntegrations);
  }

  private getClone(array: integrationItem[]): integrationItem[] {
    return JSON.parse(JSON.stringify(array)) as integrationItem[];
  }

  private sort(a: integrationItem, b: integrationItem) {
    if (a.name > b.name) {
      return 1;
    }
    if (a.name < b.name) {
      return -1;
    }
    return 0;
  }

  getSrc(item: integrationItem): string {
    return '/assets/images/data-sharing/intergrations/' + item.name + '.png';
  }

  ngOnInit(): void {
  }

  onSearchChanged(filter: string) {
    this.searchValue = filter;
    this.filtered = this.getClone(this.allIntegrations.filter(x => x.name.includes(filter)));
  }

  onOpenWebsite(url: string) {
    // window.open('https://support.tekom.pl/portal/pl/kb/articles/' + url, '_blank')!.focus();
  }

  public onEmptyStateSubmit(): void {
    this.onEmptyStateSubmit$.emit();
    this.searchValue = '';
    this.setInitValues();
  }

}
